import { Grid } from "@mui/material";
import { ClearSearchButton, FilterByUploadDateTypes, FilterForm } from "../Filters";
import { TreeBranch } from "../TreeSelect/TreeSelect";
import { FilterPublishedExports } from "../common/FilterPublishedArtifacts";

export interface IDateRange {
  start?: string;
  end?: string;
}

interface ICreateDefaultExportStatusFilters {
  project?: string | null;
  exportName?: string | null;
}

// Shared so the factory's return type and the onChange setter cannot drift apart.
export interface IExportStatusFilter {
  dateRangeType: string;
  exportName?: string | null;
  project?: string | null;
}

const createDefaultExportStatusFilters = ({
  project,
  exportName,
}: ICreateDefaultExportStatusFilters): IExportStatusFilter => {
  return { dateRangeType: "reportDate", exportName, project };
};

interface IExportStatusFilters {
  dateRangeType?: string | null;
  exportName?: string | null;
  project?: string | null;
  onChange: React.Dispatch<React.SetStateAction<IExportStatusFilter>>;
  onClear: () => void;
}

const ExportStatusFilters = ({
  dateRangeType = "",
  exportName = "",
  project = "",
  onChange,
  onClear,
}: IExportStatusFilters) => {
  const getCurrent = () => {
    return { dateRangeType, exportName, project };
  };

  const handleChange = (newFilters: Partial<IExportStatusFilter>) => {
    onChange(Object.assign({}, getCurrent(), newFilters));
  };

  const handleChangeTreeSelect = (elem: TreeBranch | TreeBranch[]) => {
    if (Array.isArray(elem)) {
      handleChange({ exportName: null, project: null });
      return;
    }
    handleChange(elem?.extraInfo?.filterValue ?? {});
  };

  return (
    <FilterForm>
      <Grid>
        <FilterByUploadDateTypes
          id="Uploads"
          dateRangeType={dateRangeType}
          onChange={(value) => handleChange({ dateRangeType: value ?? "" })}
        />
      </Grid>
      <Grid>
        <FilterPublishedExports
          id="exportFilterPublished"
          projectNames={[project ?? ""]}
          exportNames={[exportName ?? ""]}
          onChange={handleChangeTreeSelect}
          allowSelectProjects={true}
          allowSelectSuspended={true}
        />
      </Grid>
      <Grid sx={{ marginTop: "20px" }}>
        <ClearSearchButton onClear={onClear} />
      </Grid>
    </FilterForm>
  );
};

export { createDefaultExportStatusFilters, ExportStatusFilters };
